interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={isCenter ? 'text-center mx-auto max-w-2xl' : 'max-w-2xl'}>
      <span className="inline-flex items-center gap-2 text-xs font-label font-medium tracking-widest uppercase text-primary-600">
        <span className="w-5 h-px bg-primary-400"></span>
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {description && (
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
}